import { FC, useRef, useEffect } from 'react'
import * as d3 from 'd3'
import { ChartData } from '../types'
import { renderPieChart, renderBarChart, renderLineChart } from '../utils'
import { ChartContainer, ChartTitle } from '../chatArea.styles'

interface D3ChartProps {
  config: ChartData
}

const D3Chart: FC<D3ChartProps> = ({ config }) => {
  const svgRef = useRef<SVGSVGElement>(null)

  useEffect(() => {
    if (!svgRef.current || !config.data) return

    const svg = d3.select(svgRef.current)
    svg.selectAll('*').remove()

    const width = 400
    const height = 250
    const margin = { top: 30, right: 30, bottom: 40, left: 50 }

    svg.attr('width', width).attr('height', height)

    if (config.type === 'pie') {
      renderPieChart(svg, config, width, height)
    } else if (config.type === 'bar') {
      renderBarChart(svg, config, width, height, margin)
    } else if (config.type === 'line') {
      renderLineChart(svg, config, width, height, margin)
    }
  }, [config])

  return (
    <ChartContainer>
      {config.title && <ChartTitle variant="subtitle2">{config.title}</ChartTitle>}
      <svg ref={svgRef} />
    </ChartContainer>
  )
}

export default D3Chart
